(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/board.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/board.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.Board = Marionette.CollectionView.extend({
    snapSize: 43, 
    activeSegment: 0,
    log: new svs.core.log.Logger('svs.maltipset.views.Board'),
    className: function() {
      var className = 'maltipset-swiper-wrap js-slider-wrapper slider-wrapper';

      if (!this.options.coupon.isEnabled()) {
        className += ' disabled';
      }

      if (this.options.coupon.isMOrRSystem()) {
        className += ' system-active';
      }

      return className;
    },
    childView: svs.maltipset.views.Row,
    initialize: function() {
      this.coupon = this.options.coupon;
      this.snapSize = 43;
      this.listenToOnce(this.coupon, 'coupon:empty', this.onCouponEmpty, this);
      var self = this;
      var boardContainer = $('.maltipset-board-container');
      var leftArrow = $('.maltipset-swipe-arrow-left');
      var rightArrow = $('.maltipset-swipe-arrow-right');
      var playContent = $('.maltipset-play-content');

      if (svs.core.detect.formfactor.desktop()) {
        leftArrow.css('left', boardContainer.offset().left);
        rightArrow.css(
          'left',
          playContent.offset().left + playContent.width() - 60
        );
      }
      if (!svs.core.detect.formfactor.mobile()) {
        $(window).resize(function() {
          self.containerWidth = self.$el.parent().width();
          if (svs.core.detect.formfactor.desktop()) {
            leftArrow.css('left', boardContainer.offset().left);
            rightArrow.css(
              'left',
              playContent.offset().left + playContent.width() - 60
            );
          }
          if (self.coupon.get('board').swiper) {
            self.activateRowByNum(self.coupon.get('activeRowNum') + 1);
            self.coupon.get('board').swiper.resize();
          }
        });
      }
    },
    events: {
      'click .maltipset-board-row:not(.maltipset-row-active)': 'rowClicked'
    },
    onCouponEmpty: function() {
      if (!this.coupon.isMOrRSystem() && this.coupon.get('board')) {
        this.activateRowByNum(1);
        this.coupon.get('board').swiper.scrollTo(0, false, true);
      }
    },
    rowClicked: function(e) {
      if (this.options.coupon.isEnabled()) {
        this.activateRowByNum($(e.currentTarget).data('rownum'));
      }
    },
    activateRowByNum: function(rowNo) {
      rowNo = rowNo || 1;
      if (svs.core.detect.formfactor.mobile()) {
        this.containerWidth = this.containerWidth ?
          this.containerWidth :
          this.$el.offset().left;
      } else {
        this.containerWidth = this.containerWidth ?
          this.containerWidth :
          this.$el.parent().width();
      }
      this.rows =
        this.rows && this.rows.length ?
          this.rows :
          this.$el.find('.maltipset-board-row');

      var isOutsideBounds =
        rowNo - this.activeSegment >
        Math.floor(this.containerWidth / this.snapSize);

      if (this.coupon.get('board').swiper && isOutsideBounds) {
        this.coupon.get('board').swiper.scrollTo(rowNo - 1);
      }

      this.rows.removeClass('maltipset-row-active');

      $(this.rows[rowNo - 1]).addClass('maltipset-row-active');
      this.coupon.setSelectedRow(rowNo - 1);
    },
    onAttach: function() {
      this.onClose();
      this.arrows = $('.maltipset-swipe-arrow');
      if (!this.coupon.isMOrRSystem() && !this.coupon.get('xpertBaseRowMode')) {
        this.containerWidth = this.containerWidth ?
          this.containerWidth :
          this.$el.parent().width();
        var swipeWrap = document.getElementsByClassName('js-maltipset-slider-container')[0];
        var self = this;
        this.rows = this.$el.find('.maltipset-board-row');

        var swiperObj = new svs.components.Slider(swipeWrap, {
          slideOnDrag: true,
          snapSize: this.snapSize,
          bouncing: !svs.core.detect.formfactor.desktop()
        });

        swiperObj.on('change', this.segmentdidchangeListener.bind(this));

        this.coupon.get('board').swiper = swiperObj;

        if (svs.core.detect.formfactor.desktop()) {
          if (
            $('.js-slider-wrapper').width() >
            $('.maltipset-board-container').width()
          ) {
            $(this.arrows[1]).removeClass('hide-arrow');
            this.arrows.click(function() {
              var numberOfRows = Math.floor(self.$el.parent().outerWidth() / self.snapSize);

              swiperObj.scrollTo(swiperObj.getCurrentSlideIndex() +
                  ($(this).hasClass('maltipset-swipe-arrow-right') ?
                    numberOfRows :
                    numberOfRows * -1));
            });

            swiperObj.on('reachedend', this.reachedendListener.bind(this));
            swiperObj.on('reachedstart', this.reachedstartListener.bind(this));
            swiperObj.on('scrollstart', this.scrollstartListener.bind(this));
          }
        }
      } else if (svs.core.detect.formfactor.desktop()) {
        this.arrows.addClass('hide-arrow');
      }
    },
    onClose: function() {
      var swiper = this.coupon.get('board').swiper;
      if (swiper) {
        swiper.off('reachedend', this.reachedendListener);
        swiper.off('reachedstart', this.reachedstartListener);
        swiper.off('scrollstart', this.scrollstartListener);
        swiper.destroy();
      }
    },

    reachedendListener: function() {
      $(this.arrows[1]).addClass('hide-arrow');
      $(this.arrows[0]).removeClass('hide-arrow');
    },
    reachedstartListener: function() {
      $(this.arrows[0]).addClass('hide-arrow');
      if (
        this.collection.coupon.get('system') ===
        svs.maltipset.constants.SYSTEM.NO_SYSTEM
      ) {
        $(this.arrows[1]).removeClass('hide-arrow');
      }
    },
    scrollstartListener: function() {
      $(this.arrows[1]).removeClass('hide-arrow');
      $(this.arrows[0]).removeClass('hide-arrow');
    },
    segmentdidchangeListener: function(e) {
      this.activeSegment = e.index;
    }
  });
})(Backbone, _, svs);


 })(window);